import { render, staticRenderFns } from "./OpenTask.vue?vue&type=template&id=2cdd00d6"
import script from "./OpenTask.vue?vue&type=script&lang=js"
export * from "./OpenTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports